import { forwardRef } from 'react';

import { Combobox, ComboboxData, ComboboxItem } from 'ui';

import { getKeyFromData } from '../utils/getKeyFromData';
import { isGroup } from '../utils/isGroup';

/**
 *
 * Renders a searchable option
 * if the option is a string, it will render a string option
 * if the option is a ComboboxItem, it will render a ComboboxItem option
 * if the option is a ComboboxItemGroup, it will render a ComboboxItemGroup option
 * @param item - The item to render
 * @returns
 */
const SearchableOption = forwardRef<
  HTMLDivElement,
  { item: ComboboxData[number]; activeOptionId?: ComboboxItem['value'] }
>(({ item, activeOptionId }, ref) => {
  if (typeof item === 'string') {
    return (
      <Combobox.Option value={item} key={item} ref={ref} active={activeOptionId === item}>
        {item}
      </Combobox.Option>
    );
  }
  if (typeof item === 'object' && 'value' in item) {
    return (
      <Combobox.Option
        value={item.value}
        key={item.value}
        ref={ref}
        active={activeOptionId === item.value}
      >
        {item.label}
      </Combobox.Option>
    );
  }
  if (isGroup(item)) {
    return (
      <Combobox.Group label={item.group} key={item.group} ref={ref}>
        {item.items.map((groupItem, index: number) => (
          <SearchableOption
            item={groupItem}
            key={getKeyFromData(groupItem) ?? index}
            activeOptionId={activeOptionId}
          />
        ))}
      </Combobox.Group>
    );
  }
  return null;
});

SearchableOption.displayName = 'SearchableOption';
export { SearchableOption };
